import { useApiResultQuery } from 'src/Libs/api'
import { getDownloadCategory, getDownloadFile } from '../api'
import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { DownloadFileItem, DownloadsCategoryModel, DownloadsFilter } from '../models/downloads.model'
import { transformFilters } from '../utils'
import { useTypedSelector } from 'src/State/RootReducer'

/**
 * Hook to get all files for download section
 */
export function useDownloadFiles(downloadItemId: number, filter: DownloadsFilter, isFile: true): [DownloadFileItem | undefined, boolean, boolean]
export function useDownloadFiles(
  downloadItemId: number,
  filter: DownloadsFilter,
  isFile?: boolean
): [DownloadsCategoryModel | undefined, boolean, boolean]
/* eslint-disable-next-line */
export function useDownloadFiles(downloadItemId: number, filter: DownloadsFilter, isFile = false) {
  const authFetch = useAuthFetchWithResponse()
  const filterString = transformFilters(filter)
  const refresh = useTypedSelector(state => state.apiView.refresh)

  const {
    data: categoryData,
    isError: categoryIsError,
    isLoading: categoryIsLoading,
  } = useApiResultQuery({
    queryKey: ['download-category', downloadItemId, filterString, refresh],
    fetchFunction: () => getDownloadCategory(downloadItemId, authFetch, filterString),
    options: {
      enabled: !isFile,
      staleTime: 0,
    },
  })

  const {
    data: fileData,
    isError: fileIsError,
    isLoading: fileIsLoading,
  } = useApiResultQuery({
    queryKey: ['download-file', downloadItemId, filterString, refresh],
    fetchFunction: () => getDownloadFile(downloadItemId, authFetch, filterString),
    options: {
      enabled: isFile,
      staleTime: 0,
    },
  })

  if (isFile && fileIsError) {
    return [undefined, fileIsLoading, fileIsError]
  } else if (categoryIsError) {
    return [undefined, categoryIsLoading, categoryIsError]
  }

  return [categoryData || fileData, categoryIsLoading || fileIsLoading, categoryIsError || fileIsError]
}
